var map = {
	"./african.svg": [
		57271,
		271
	],
	"./asian.svg": [
		34187,
		187
	],
	"./balkan.svg": [
		41570,
		570
	],
	"./easternEurope.svg": [
		43682,
		682
	],
	"./french.svg": [
		85264,
		264
	],
	"./iberian.svg": [
		89877,
		877
	],
	"./indian.svg": [
		57055,
		55
	],
	"./italian.svg": [
		15,
		15
	],
	"./latinAmerica.svg": [
		68957,
		957
	],
	"./mediterranean.svg": [
		9664,
		664
	],
	"./mexican.svg": [
		95878,
		878
	],
	"./northAfrica.svg": [
		27416,
		416
	],
	"./northAmerica.svg": [
		86781,
		781
	],
	"./oceania.svg": [
		97661,
		661
	],
	"./oriental.svg": [
		40793,
		793
	],
	"./scandinavian.svg": [
		2779,
		779
	],
	"./turkish.svg": [
		20120,
		120
	],
	"./vegan.svg": [
		16946,
		946
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2842;
module.exports = webpackAsyncContext;